module.exports = __webpack_public_path__ + "img/28.afae4c44.png";